import { render, staticRenderFns } from "./RegisterSubModule.vue?vue&type=template&id=1c394df8&scoped=true&"
import script from "./RegisterSubModule.vue?vue&type=script&lang=js&"
export * from "./RegisterSubModule.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSubModule.vue?vue&type=style&index=0&id=1c394df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c394df8",
  null
  
)

export default component.exports